import React from 'react';

// this is the equivalent to the createStore method of Redux
// https://redux.js.org/api/createstore

export const appContextDefaultValue = {};

const AppContext = React.createContext(appContextDefaultValue);
export default AppContext;
